export const templates = {
    collapseButtonText:
        `{{#collapsed}}
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path>
          </svg>
         {{/collapsed}}
         {{^collapsed}}
         <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clip-rule="evenodd"></path>
         </svg>
         {{/collapsed}}`
}
/*
 NOTE: Button is absolutely positioned over the
 heading so that the user can click that entire area
 to collapse or expand the panel
 */
export const panelClasses = {
    root: '',
    header: 'py-3 pr-8 w-full flex items-center justify-between transition relative text-left text-base text-gray-400 hover:text-gray-500',
    collapsedRoot: 's-collapsed',
    collapseButton: 'pr-4 flex items-center justify-end absolute inset-0 w-full'
}

export const wrapHeading = (label) => {
    return `<span class="font-bold text-gray-900 uppercase tracking-widest text-sm">${label}</span>`
}

export const isCollapsed = (selector) => {
    const element = selector
    return typeof element.dataset.collapsed !== 'undefined';
}
